import { useDispatch, useSelector } from "react-redux";
import { slices } from "../redux";

export const useOnlineOptions = () => {
    const dispatch = useDispatch();
    const option = useSelector((state) => state.onlineOptions);

    return [option, (option) => dispatch(slices.onlineOptions.actions.setOption(option))];
};
